import { render, staticRenderFns } from "./NoVulnerabilitiesBlock.vue?vue&type=template&id=50e02ca0&scoped=true"
import script from "./NoVulnerabilitiesBlock.vue?vue&type=script&lang=js"
export * from "./NoVulnerabilitiesBlock.vue?vue&type=script&lang=js"
import style0 from "./NoVulnerabilitiesBlock.vue?vue&type=style&index=0&id=50e02ca0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e02ca0",
  null
  
)

export default component.exports